import { style } from 'typestyle'

export const cardListDiv = style({
    display: 'flex',
    flexDirection: 'column',
    rowGap: '1rem',
})
